import React from 'react';
import { Cancel, CheckCircle, Error, HourglassEmpty, ReportProblemOutlined, Sync, WatchLater } from '@material-ui/icons';
import { useGenericStyles } from 'common/genericStyles';
import { Grid, Typography } from '@material-ui/core';

interface LegendaStatusProps {
  exibirStatusOpr?: boolean;
  exibirStatusAdmFiduciario?: boolean;
}

const LegendaStatus: React.FC<LegendaStatusProps> = ({ exibirStatusOpr = false, exibirStatusAdmFiduciario = false }) => {
  const classes = useGenericStyles();

  return (
    <Grid container justifyContent="flex-start" spacing={8}>
      <Grid item style={{ display: 'inline-flex' }}>
        <CheckCircle fontSize="small" className={classes.successIcon} />
        <Typography display="inline">{'Concluída'}</Typography>
      </Grid>
      <Grid item style={{ display: 'inline-flex' }}>
        <Error fontSize="small" className={classes.waitingIcon} />
        <Typography display="inline">{'Em Análise'}</Typography>
      </Grid>
      {exibirStatusAdmFiduciario && (
        <Grid item style={{ display: 'inline-flex' }}>
          <ReportProblemOutlined fontSize="small" className={classes.waitingIcon} />
          <Typography display="inline">{'Aguardando aprovação ADM Fiduciário'}</Typography>
        </Grid>
      )}
      {exibirStatusOpr && (
        <Grid item style={{ display: 'inline-flex' }}>
          <HourglassEmpty fontSize="small" className={classes.warningIcon} />
          <Typography display="inline">{'Aceite Parcial (Aguardando Contraparte)'}</Typography>
        </Grid>
      )}
      <Grid item style={{ display: 'inline-flex' }}>
        <WatchLater fontSize="small" className={classes.warningIcon} />
        <Typography display="inline">{'Aguardando Liquidação'}</Typography>
      </Grid>
      {exibirStatusOpr && (
        <Grid item style={{ display: 'inline-flex' }}>
          <Sync fontSize="small" className={classes.warningIcon} />
          <Typography display="inline">{'Liquidação em Processamento'}</Typography>
        </Grid>
      )}
      <Grid item style={{ display: 'inline-flex' }}>
        <Cancel fontSize="small" className={classes.errorIcon} />
        <Typography display="inline">{'Cancelada ou Reprovada'}</Typography>
      </Grid>
    </Grid>
  );
};

export default LegendaStatus;
